var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"type":"submit","color":"secondary","depressed":"","loading":_vm.loading,"disabled":!_vm.valid,"form":_vm.form},on:{"click":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._v(" "+_vm._s(_vm.$t('generateApiKeyButton.generateText'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }